import { RootState } from '../store';
import { createDeepEqualSelector } from './index';

export const autocompleteSelector = (
  state: RootState,
): RootState['autocomplete'] => state.autocomplete;

export const getSuggestionsSelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.suggestions,
);

export const getSuggestedItemsSelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.items,
);

export const getHistorySelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.history?.slice(0, 5) || [],
);

export const getIsLoadingSelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.isLoading,
);

export const getQuerySelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.query,
);

export const getShadowQuerySelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.shadowQuery,
);

export const getIsOpenSelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.isOpen,
);

export const getDefaultSuggestionsSelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.defaultSuggestions,
);

export const isSuggestionsRequestedSelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.isSuggestionsRequested,
);

export const currentItemIndexSelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.currentItemIndex,
);

export const currentProductIndexSelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.currentProductIndex,
);

export const xRequestIdSelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.xRequestId,
);

export const hoveredItemSelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.hoveredItem,
);

export const itemsQuerySelector = createDeepEqualSelector(
  autocompleteSelector,
  (autocomplete) => autocomplete.itemsQuery,
);
